import type { CustomWindow } from '@utils/models/customwindow';

declare let window: CustomWindow;

const activateStatusAlertForScreenReaders = (blockElement: HTMLElement) => {
  if (blockElement.dataset.workingWithStatusAlert === "true") {
    return;
  }

  blockElement.dataset.workingWithStatusAlert = "true";

  const textWrapper = blockElement.querySelector(".video-block__player-container-text-inner") as HTMLDivElement;
  const textContent = textWrapper.innerHTML;
  textWrapper.innerHTML = "";

  setTimeout(() => {
    textWrapper.setAttribute("tabindex", "-1");
    textWrapper.focus();
    textWrapper.innerHTML = textContent;
  }, 100);
};

export const initializeConsentCheck = (elements: NodeListOf<HTMLElement>) => {
  if (window.Cookiebot?.consent?.marketing) {
    return;
  }

  elements.forEach(blockElement => {
    blockElement.dataset.workingWithStatusAlert = "false";

    if (blockElement.dataset.initializedConsent === "true") {
      return;
    }

    blockElement.classList.add("video-block__content--prevent-video");

    blockElement.addEventListener("click", () => {
      if (!window.Cookiebot?.consent?.marketing) {
        blockElement.classList.add("video-block__content--show-video");
        activateStatusAlertForScreenReaders(blockElement);
      }
    });

    blockElement.addEventListener("keypress", (event: KeyboardEvent) => {
      if (!window.Cookiebot?.consent?.marketing && event.key === 'Enter') {
        blockElement.classList.add("video-block__content--show-video");
        activateStatusAlertForScreenReaders(blockElement);
      }
    });

    blockElement.dataset.initializedConsent = "true";
  });
};
